import React from 'react';

export default function CourseSyllabus({ modules = [] }) {
  return (
    <div className="container mx-auto px-4 py-16">
      <h2 className="text-3xl font-bold mb-8">Course Curriculum</h2>
      <div className="space-y-4" data-testid="course-syllabus">
        {modules.length > 0 ? (
          modules.map((module, index) => (
            <div
              key={module.module_id || index}
              data-testid={`syllabus-module-${index + 1}`}
              className="bg-gray-900 rounded-xl p-6 border border-gray-800"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="bg-purple-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold">
                      {index + 1}
                    </span>
                    <h3 className="text-xl font-bold">{module.title}</h3>
                  </div>
                  <p className="text-gray-400 ml-11">{module.description}</p>
                </div>
                <div className="text-sm text-gray-500 ml-4">{module.duration}</div>
              </div>

              {module.topics?.length > 0 && (
                <div className="ml-11 mt-4">
                  <div className="text-sm font-semibold text-gray-400 mb-2">Topics Covered:</div>
                  <ul className="grid md:grid-cols-2 gap-2">
                    {module.topics.map((topic) => (
                      <li key={topic} className="text-sm text-gray-300 flex items-start gap-2">
                        <span className="text-purple-400">•</span>
                        <span>{topic}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {module.lesson_narrative && (
                <div className="ml-11 mt-4 p-4 bg-gray-800 rounded-lg border border-gray-700">
                  <div className="text-sm font-semibold text-purple-400 mb-2">📖 Lesson Content Available</div>
                  <p className="text-xs text-gray-400">Full lesson narrative from the Living Library</p>
                </div>
              )}

              {module.review_questions?.length > 0 && (
                <div className="ml-11 mt-4 p-4 bg-gray-800 rounded-lg border border-gray-700">
                  <div className="text-sm font-semibold text-green-400 mb-2">
                    ❓ {module.review_questions.length} Review Questions Included
                  </div>
                </div>
              )}

              {module.source_documents?.length > 0 && (
                <div className="ml-11 mt-4 p-4 bg-gray-800 rounded-lg border border-gray-700">
                  <div className="text-sm font-semibold text-cyan-400 mb-2">
                    📚 {module.source_documents.length} Source Documents (
                    {module.total_source_words?.toLocaleString() || 'N/A'} words)
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <p className="text-gray-400">Course curriculum coming soon</p>
        )}
      </div>
    </div>
  );
}
